// extracted by mini-css-extract-plugin
module.exports = {"selector":"select_selector__tmXcw","inputWrapper":"select_inputWrapper__AqAlm"};